<template>
  <listing-layout>
    <div slot="heading" class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="h2 mb-0">Pending Horse Updates</h1>
    </div>
    <div slot="content">
      <div class="alert alert-success" v-if="success">{{success}}</div>
      <div class="alert alert-info" v-if="status">{{status}}</div>
      <div class="alert alert-warning" v-if="error">{{error}}</div>
      <data-table :dataRows="rows" :dataColumns="columns" :options="options">
        <tableTextTemplate slot-scope="{ row }" slot="expandedHeader" :text="row.name" :link="'Pending Horse'" :row="row" :options="{ showLinks: true, expandMobile: true }" />
        <div slot-scope="{ row }" slot="expandedRow">
          <ul class="list-unstyled mb-0 pt-2">
            <li>
              <strong>Owner: </strong>
              <tableTextTemplate :text="row.owner" :row="row" :options="{ showRegistered: true, inline: true }" />
            </li>
            <li>
              <strong>Date of Birth: </strong>
              <tableTextTemplate :text="row.dob ? new Date(row.dob.replace(/-/g, '/')).toLocaleDateString('en-AU') : ''" :row="row" :options="{ inline: true }" />
            </li>
            <li>
              <strong>Sex: </strong>
              <tableTextTemplate :text="row.gender" :row="row" :options="{ inline: true }" />
            </li>
            <li>
              <strong>Status: </strong>
              <tableTextTemplate :text="row.status ? row.status.name : ''" :row="row" :options="{ inline: true }" />
            </li>
          </ul>
        </div>
      </data-table>
    </div>
  </listing-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */
import axios from 'axios'
import listingLayout from '@/components/ListingLayout'
import dataTable from '@/components/DataTable'
import tableTextTemplate from '@/components/DataTableFields/Text'

export default {
  name: 'PendingRegistrations',
  props: ['success', 'status'],
  components: {
    'listing-layout': listingLayout,
    'data-table': dataTable,
    tableTextTemplate
  },
  data() {
    return {
      error: '',
      rows: [],
      columns: [
        {
          label: 'Horse Name',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.name" :link="'Pending Horse'" :row="row" :options="{ showLinks: true, showRegistered: true }" />`
          }),
          representedAs(row) { return `${row.name}` }
        },
        {
          label: 'Owner',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.owner" :row="row" />`
          }),
          representedAs(row) { return `${row.owner}` }
        },
        {
          label: 'Date of Birth',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.dob ? new Date(row.dob.replace(/-/g, '/')).toLocaleDateString('en-AU') : ''" :row="row" :options="{}" />`
          }),
          representedAs(row) { return `${row.dob ? new Date(row.dob.replace(/-/g, '/')).toLocaleDateString('en-AU') : ''}` }
        },
        {
          label: 'Sex',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.gender" :row="row" />`
          }),
          representedAs(row) { return `${row.gender}` }
        },
        {
          label: 'Status',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.status ? row.status.name : ''" :row="row" />`
          }),
          representedAs(row) { return `${row.status ? row.status.name : ''}` }
        }
      ],
      options: {
        filter: {
          registered: [
            { name: 'All', value: 'all' },
            { name: 'Registered', value: true },
            { name: 'Unregistered', value: false }
          ]
        },
        activeFilter: {
          registered: 'all'
        },
        search: true,
        addHorse: this.$isUser || this.$isSecretary,
        loaded: false
      }
    }
  },
  mounted() {
    axios.post(`${this.$api}/admin/horse-pending`).then((response) => {
      if (response.data.status === 'success') {
        this.options.loaded = true
        response.data.data.forEach((horse) => {
          horse.owner = ''
          horse.owners.forEach((value, key, array) => {
            horse.owner += `${value.first_name} ${value.last_name}`

            if (key !== (array.length - 1)) {
              horse.owner += ', '
            }
          })
          // eslint-disable-next-line
          let theOwners = horse.owners.reduce((a, b) => a.concat(b), [])
          // eslint-disable-next-line
          theOwners = theOwners.map(o => ({ [o.id]: o.name }))
          // console.log(theOwners)
        })

        this.error = ''
        // console.log(response.data.data)
        this.rows = response.data.data
      } else {
        this.error = 'Unable to receive data from the server. Please reload the page.'
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Admin/Pending/PendingRegistrations.vue